<script lang="ts" setup>
import { toTypedSchema } from '@vee-validate/zod';
import { computed, inject, ref, watchEffect } from 'vue';
import { z } from 'zod';
import { storeToRefs } from 'pinia';
import { CrmRelationsRelatieContext } from '@services/crm-public/orval-api/model/crmRelationsRelatieContext';
import { useBlurValidatedField } from '@shared/validation/useBlurValidatedField';
import VInput from '@shared/form/VInput/VInput.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { isDisabledInjectionKey, isReadonlyInjectionKey } from '../keys';
import { useRelatieStuurgegevensStore } from '../../relatieStuurGegevensStore';

const relatieStuurGegevensStore = useRelatieStuurgegevensStore();
const { relatieContext } = storeToRefs(relatieStuurGegevensStore);
const { value: hasDisabledParent } = inject(isDisabledInjectionKey, { value: ref(false) });
const { value: hasReadonlyParent } = inject(isReadonlyInjectionKey, { value: ref(false) });

const initialValue = ref<string | undefined>();
const isRequired = computed(
  () => relatieContext.value === CrmRelationsRelatieContext.Aanvraag || !!initialValue.value,
);

const maxLength = 63;
const validationSchema = computed(() => {
  const emailValidation = z.string().email().max(maxLength);
  const validation = isRequired.value
    ? emailValidation
    : emailValidation.optional().or(z.literal(''));
  return toTypedSchema(validation);
});

const { errors, value, meta, handleBlur } = useBlurValidatedField('email', validationSchema);

watchEffect(() => {
  initialValue.value = meta.initialValue;
});

const fieldId = 'relatiegegevens-relatie-email';
</script>

<template>
  <FieldRowV2
    :errors="errors"
    label="E-mailadres"
    :label-for="fieldId"
    :required="!hasReadonlyParent && isRequired"
    v-bind="$attrs"
  >
    <VInput
      v-if="!hasReadonlyParent"
      v-model="value"
      @blur="handleBlur"
      :has-error="!!errors.length"
      :id="fieldId"
      :is-disabled="hasDisabledParent"
      :is-readonly="hasReadonlyParent"
      :is-required="isRequired"
      :max-length="maxLength"
      type="email"
    />
    <div v-else>{{ value ?? '-' }}</div>
  </FieldRowV2>
</template>
